export const SCORE_PERCENT = 3;
export const BASE_SALARY = 8000;
export const SPECIALIST = "מומחה";
export const MANAGERS = "מנהלים";
export const NO_SOCIAL = 'לא עו"ס לחוק';
export const URL_SPECIALIST =
  "https://www.gov.il/he/service/apply-for-social-work-expertise-recognition";
export const TOOLTIP_TEXT_SPECIALIST =
  'מומחיות כפי שהוכרה ע"י האיגוד עד 2015 וע"י משרד הרווחה מאז 2015';
export const URL_RESULT =
  "https://www.socialwork.org.il/%D7%AA%D7%9C%D7%95%D7%A9-%D7%94%D7%A9%D7%9B%D7%A8-%D7%91%D7%A8%D7%A4%D7%95%D7%A8%D7%9E%D7%94";

export const managerialLevel = ["0", "1", "2", "3", "4", "5", "6", "7", "7*"];
export const lawSupplementLevel = [
  'לא עו"ס לחוק',
  'עו"ס סדרי דין(חוק החוסים)',
  'עו"ס בשירות מבחן',
  'עו"ס חוק הסעד (מש"ה)',
  'עו"ס ביחידות הסיוע',
  'עו"ס חוק האימוץ',
  'עו"ס מפקח/ת נפגעי עבירה',
  'עו"ס לחוק הנוער',
  'עו"ס סדרי דין',
  'עו"ס מעצרים בשירות מבחן',
  'עו"ס חוקר/ת ילדים',
];
export const formDetails = [
  {
    name: "jobPercentage",
    label: "חלקיות משרה",
    tooltip:
        "יש למלא את אחוזי המשרה בפועל (ללא תוספת חלקיות משרה, אם ישנה). שימו לב, כאשר עובדת מבצעת שני תפקידים שונים כדאי לעשות הערכה לכל תפקיד בנפרד",
    placeHolder: "%",
    isNumber: true,
    requierd: true,
  },
  {
    name: "senioritySalary",
    label: "וותק לשכר",
    isNumber: true,
    tooltip:
      'יש למלא את מספר שנות הוותק (העבודה) שלך במקצוע לאחר הרישום בפנקס העו"ס + שנות שירות צבאי/לאומי/אזרחי מוכר וכל ותק אחר מוכר בתלוש אחר שאינו במקצוע (לדוגמא-ותק נגרר). שימו לב לא לחשב שנות ותק של מסלולים נמרצים ובגין לימודי הסבה! יש למלא מספר שנים עגול(ללא חודשים)',
    url: "https://www.socialwork.org.il/%D7%AA%D7%95%D7%A1%D7%A4%D7%AA-%D7%95%D7%AA%D7%A7-%D7%9C%D7%A9%D7%9B%D7%A8",
    requierd: true,
  },
  {
    name: "professionalSeniority",
    label: "וותק מקצועי",
    isNumber: true,
    tooltip:
      'יש למלא את מספר שנות הוותק (העבודה) שלך במקצוע ממועד הרישום בפנקס העו"ס. שימו לב לא לחשב שנות ותק מכל מקור אחר, לרבות של מסלולים נמרצים!',
    url: "https://www.socialwork.org.il/%D7%A8%D7%9E%D7%94-%D7%9E%D7%A7%D7%A6%D7%95%D7%A2%D7%99%D7%AA-%7Cfwsa%7C-%D7%95%D7%AA%D7%A7-%D7%9E%D7%A7%D7%A6%D7%95%D7%A2%D7%99-%D7%95%D7%99%D7%93%D7%A2-%D7%9E%D7%A7%D7%A6%D7%95%D7%A2%D7%99",
    requierd: true,
  },
  {
    name: "degree",
    label: "תואר",
    isSelect: true,
    options: ["תואר ראשון", "תואר שני", 'ד"ר'],
    tooltip: "יש לסמן את התואר האחרון שהוכר לך לשכר.",
    requierd: true,
    url: "https://www.socialwork.org.il/%D7%A8%D7%9E%D7%94-%D7%9E%D7%A7%D7%A6%D7%95%D7%A2%D7%99%D7%AA-%7Cfwsa%7C-%D7%95%D7%AA%D7%A7-%D7%9E%D7%A7%D7%A6%D7%95%D7%A2%D7%99-%D7%95%D7%99%D7%93%D7%A2-%D7%9E%D7%A7%D7%A6%D7%95%D7%A2%D7%99",
  },
  {
    name: "studyHours",
    label: "היקף שעות לימוד",
    isNumber: true,
    tooltip:
      "יש למלא את מספר שעות הלימוידם שהוכרו לך באישור גמול ההשתלמות האחרון + שעות לימודי תעודה שהוכרו לשכר בנפרד (למי שיש תוספת 2.5% בשכר)",
    url: "https://www.socialwork.org.il/%D7%A8%D7%9E%D7%94-%D7%9E%D7%A7%D7%A6%D7%95%D7%A2%D7%99%D7%AA-%7Cfwsa%7C-%D7%95%D7%AA%D7%A7-%D7%9E%D7%A7%D7%A6%D7%95%D7%A2%D7%99-%D7%95%D7%99%D7%93%D7%A2-%D7%9E%D7%A7%D7%A6%D7%95%D7%A2%D7%99",
    requierd: true,
  },
  {
    name: "managerLevel",
    label: "רמה ניהולית",
    isSelect: true,
    tooltip:
      "הרמה הניהולית נקבעת לפי התפקיד והתקן אותו ממלא/ת העובד/ת בהתאם לטבלה כאן באתר האיגוד",
    options: managerialLevel,
    url: "https://www.socialwork.org.il/%D7%A8%D7%9E%D7%94-%D7%A0%D7%99%D7%94%D7%95%D7%9C%D7%99%D7%AA",
    requierd: true,
  },
  {
    name: "lawSupplement",
    label: "רמה תוספת חוק",
    isSelect: true,
    tooltip:
      "רמת תוספת החוק נקבעת לעובדת שמונתה מתוקף מינוי בחוק ומבצעת את התפקיד בפועל, על פי הרשימה שכאן",
    options: lawSupplementLevel,
    url: "https://www.socialwork.org.il/%D7%AA%D7%95%D7%A1%D7%A4%D7%AA-%D7%A2%D7%91%D7%95%D7%93%D7%94-%D7%9E%D7%AA%D7%95%D7%A7%D7%A3-%D7%9E%D7%99%D7%A0%D7%95%D7%99-%D7%91%D7%97%D7%95%D7%A7",
    requierd: true,
  },
  {
    name: "jobPercentageBySocialLow",
    label: "חלקיות משרה עו\"ס לחוק",
    tooltip:
        "נא למלא את אחוז המשרה המוגדר ע\"י המעסיק לתפקיד על פי חוק ",
    placeHolder: "%",
    isNumber: true,
    requierd: true,
  },

];
export const explanationFieldData = {
  newBaseSalary:
    "תוספת מתוקף מינוי בחוק מופיעה כאן בערכה למשרה מלאה. עובדות שתפקיד החוק הוא בתקן הנמוך משיעור משרתה הכולל:\nא. עובדת ששיעור משרתה הכולל גבוה מ-50%: תתקבל התוספת בשיעור חלקיות המשרה המשוייכת לתפקיד החוק ולא פחות מ-50% מגובה תוספת החוק.\nב. עובדת ששיעור משרתה הכולל נמוך מ-50%: תתקבל התוספת לחוק בגובה שיעור המשרה הכולל",
  totalPrice:
    "את השכר שיוצא בשורה זו, יש להשוות לחלקי התלוש במודל הישן שהם לערך שעה בלבד. אין להשוות סכום זה למשכורת הכוללת המתקבלת בבנק ולא לסך תשלומי הברוטו בשכר. לדוגמא להשוואה נכונה של תלוש שכר ישן מול חדש ניתן לראות באתר האיגוד.",
  banner:
    "עובד/ת יקר/ה, כלי זה נועד לסייע לך בהערכה של שכרך במסגרת רפורמת הישג. יש לעקוב אחר ההוראות בתשומת לב, ולוודא שהזנת את הנתונים באופן מלא ונכון. המחשבון אינו מחליף ייעוץ מקצועי, אינו מהווה ייעוץ לשכר או ייעוץ משפטי, ואנו ממליצים לפנות למחוזות האיגוד על מנת לקבל מידע מלא וסיוע במיצוי זכויותיך.\nפירוט השכר כולל את רכיבי השכר הבסיסיים בלבד, ואינו כולל רכיבי החזר הוצאות (כגון הוצאות נסיעה, תוספת מעונות), אינו כולל תשלומים שנתיים דוגמת הבראה וביגוד, ואינו כולל רכיבי עבודה נוספת כגון שעות נוספות או כוננות. מומלץ לעיין במידע באתר האיגוד בחלק הסכמים וזכויות למידע נוסף.\nבטופס זה - עליך להזין את הנתונים האישיים שלך, העזר בכפתור עזרה שליד כל שדה.",
  banner1:
    "עובד/ת יקר/ה, כלי זה נועד לסייע לך בהערכה של שכרך במסגרת רפורמת הישג. ",
  banner2: "יש לעקוב אחר ההוראות בסימן ? בתשומת לב, ",
  banner3: "ולוודא שהזנת את הנתונים באופן מלא ונכון. ",
  banner4: "המחשבון אינו מחליף ייעוץ מקצועי, אינו מהווה ייעוץ לשכר או משפטי, ",
  banner5:
    "ואנו ממליצים לפנות למחוזות האיגוד על מנת לקבל מידע מלא וסיוע במיצוי זכויותיך. פירוט השכר כולל את רכיבי השכר הבסיסיים בלבד, ואינו כולל רכיבי החזר הוצאות (כגון הוצאות נסיעה, תוספת מעונות), אינו כולל תשלומים שנתיים דוגמת הבראה וביגוד, ואינו כולל רכיבי עבודה נוספת כגון שעות עבודה נוספות או כוננות. מומלץ לעיין במידע באתר האיגוד בחלק רפורמת הישג למידע נוסף. בטופס זה עליך להזין את הנתונים האישיים, וחשוב להיעזר בכפתור ? שליד כל שדה כדי למלא מידע מדוייק כמה שיותר.",
};
export const FORM_FIELDS = formDetails.map((field) => field.name);
export const years = Array.from(Array(42).keys());
